import { ApiCreateLeaguePayload, ApiLeague, ApiLeagueSummary } from "griptonite-api-client";
import { z } from "zod";

import urlSchema from "@/utils/urlSchema";

import { urlsArrayToFields } from "../CompetitionProfile/forms";

export const DetailsFormSchema = z.object({
  name: z.string({ message: "Name required" }).min(1, {
    message: "Name required",
  }),
  description: z.string().nullable(),
  media: z.array(
    z.object({
      uuid: z.string(),
    }),
  ),
  websiteUrl: urlSchema.nullable(),
  facebookUrl: urlSchema.nullable(),
  instagramUrl: urlSchema.nullable(),
});

export type DetailsFormValues = z.infer<typeof DetailsFormSchema>;

export const leagueToDetailsFormValues = (league?: ApiLeague | ApiLeagueSummary) => {
  if (league && !("description" in league)) {
    return {
      name: league.name,
      description: "",
      media: [],
      ...urlsArrayToFields([]),
    };
  }
  return {
    name: league?.name || "",
    description: league?.description || "",
    media: league?.media || [],
    ...urlsArrayToFields(league?.urls || []),
  };
};

export const detailsFormValuesToPayload = (
  values: DetailsFormValues,
  venueUuid: string,
): ApiCreateLeaguePayload => {
  return {
    name: values.name,
    description: values.description,
    media: values.media.map((m) => m.uuid),
    ...(values.media.length ? { coverImage: values.media[0].uuid } : {}),
    urls: [values.websiteUrl, values.facebookUrl, values.instagramUrl].filter(Boolean) as string[],
    venueCreated: venueUuid,
  };
};

export const ScoringFormSchema = z.object({
  scoringSystem: z.enum(["SIMPLE", "OLYMPICS"]),
  topRoundsCount: z.number().min(1).nonnegative().int().nullable(),
  allRoundsContribute: z.boolean(),
});

export type ScoringFormValues = z.infer<typeof ScoringFormSchema>;

export const leagueToScoringFormValues = (league?: ApiLeague) => {
  return {
    scoringSystem: league?.scoringSystem ?? "SIMPLE",
    topRoundsCount: league?.topRoundsCount ?? null,
    allRoundsContribute: !league?.topRoundsCount,
  };
};
